<template>
  <router-view></router-view>
</template>

<script>
import Vue from 'vue';
import Utils from '@/utils';
export default {
  name: "App",

  data() {
    return {
      timeOut: ''
    };
  },

  created() {
    console.log("檢查token");
    if( Utils.Check.isNull(Vue.$cookies.get("token")))
      Utils.Auth.logOut();
    this.isTimeOut();
  },
  
  methods: {
    //頁面15分鍾無操作時登出
    startTimer() {
      let that = this;

      clearInterval(that.timeOut);
      that.timeOut = setInterval(function () {
        if(that.$route.path != '/common/login') {
          Utils.Auth.logOut();
        }
      },1000*60*15);
    },

    isTimeOut() {
      let that = this;

      document.body.onmouseup = that.startTimer;
      document.body.onmousemove = that.startTimer;
      document.body.onkeyup  = that.startTimer;
      document.body.onclick  = that.startTimer;
      document.body.ontouchend  = that.startTimer;
    },

  },

  mounted() {
    /*區分關閉和刷新，關閉退出登錄 start*/
    // window.onload = function() {
    // if (!window.sessionStorage["ISlogin"]) {
    //   Utils.Auth.logOut();
    // } else {
    //   window.sessionStorage.removeItem("ISlogin");
    // }
    // };
    // window.onunload = function() {
    //   Utils.Auth.logOut();
    // };
    window.onbeforeunload = function() {
      //判斷關閉忽略刷新
      if(event.clientX>document.body.clientWidth && event.clientY < 0 || event.altKey){ 
        Utils.Auth.logOut();
      }
    };
  },
};

</script>

<style lang="scss">
  // Import Main styles for this application
  @import "assets/scss/style";

  .right {
    text-align: right;
  }
</style>
